"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconTruckFlatbed = function SvgIconTruckFlatbed(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    fill: "currentColor",
    fillRule: "evenodd",
    viewBox: "0 0 48 48",
    "aria-label": "truck flatbed icon"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Truck Flatbed Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M38.547 13.091h-8.238v10.784H4v5.579h3.637a5.455 5.455 0 0010.91 0h10.908a5.456 5.456 0 005.454 5.455 5.457 5.457 0 005.455-5.455H44v-9.09zM13.092 32.182a2.727 2.727 0 110-5.455 2.729 2.729 0 012.728 2.727 2.732 2.732 0 01-2.728 2.728zm24.545-16.363l3.57 4.544h-8.115V15.82zM34.91 32.182a2.73 2.73 0 01-2.726-2.728 2.728 2.728 0 112.727 2.728z"
  }));
};

var _default = SvgIconTruckFlatbed;
exports.default = _default;